import Emittery from 'emittery';

// ----------------------------------------------------------------------

export const nomenclatureEmitter = new Emittery();
